import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when user clicks a word in transcript button',
  name: 'clicked_transcript_word',
  params: [
    {
      description: 'The ID of clip',
      name: 'clip_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Clicked word',
      name: 'word',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
